import { render } from "./DesignSimulationView.vue?vue&type=template&id=1b1517f5&scoped=true"
import script from "./DesignSimulationView.vue?vue&type=script&lang=js"
export * from "./DesignSimulationView.vue?vue&type=script&lang=js"

import "./DesignSimulationView.vue?vue&type=style&index=0&id=1b1517f5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b1517f5"]])

export default __exports__